<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <v-flex xs12>
            <span class="heading">Snakebite Activity Log</span>
            <div class="subtext pt-1">
              Every action recorded by officers across the state, newest first
            </div>
          </v-flex>

          <!-- filters -->
          <v-flex xs12 pt-4>
            <v-layout wrap justify-start>
              <v-flex xs12 sm6 md3 lg2 pr-md-2 pb-2>
                <v-menu
                  v-model="menuFrom"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      placeholder="From Date"
                      clearable
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fromDate" @input="menuFrom = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2 pr-md-2 pb-2>
                <v-menu
                  v-model="menuTo"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      placeholder="To Date"
                      clearable
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="toDate" @input="menuTo = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2 pr-md-2 pb-2>
                <v-select
                  v-model="district"
                  :items="districtOptions"
                  placeholder="District"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2 pr-md-2 pb-2>
                <v-select
                  v-model="role"
                  :items="roleOptions"
                  placeholder="Role"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2 pr-md-2 pb-2>
                <v-select
                  v-model="actionType"
                  :items="actionTypeOptions"
                  placeholder="Action"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2 pb-2>
                <v-text-field
                  v-model="keyword"
                  placeholder="Search"
                  outlined
                  dense
                  clearable
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- log -->
          <v-flex xs12 pt-4 v-if="items && items.length > 0">
            <v-card outlined>
              <div style="overflow-x: auto">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left tablehead">Date &amp; Time</th>
                        <th class="text-left tablehead">Action</th>
                        <th class="text-left tablehead">Description</th>
                        <th class="text-left tablehead">Officer</th>
                        <th class="text-left tablehead">Role</th>
                        <th class="text-left tablehead">District</th>
                        <th class="text-left tablehead">Incident</th>
                        <th class="text-center tablehead">View</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in items" :key="index">
                        <td class="tableitems">{{ formatDateTime(item.actionTime) }}</td>
                        <td class="tableitems">
                          <span class="action-pill">{{ item.actionType }}</span>
                        </td>
                        <td class="tableitems descriptioncell">
                          <div class="main-desc">{{ item.description }}</div>
                          <div class="detailline" v-if="item.details && item.details.length > 0">
                            <span v-for="(detail, di) in item.details" :key="di" class="detail-chip">
                              <b>{{ detail.key }}:</b> {{ detail.value }}
                            </span>
                          </div>
                          <div class="detailline" v-if="item.hospitalName">
                            <span class="detail-chip">
                              <b>Hospital:</b> {{ item.hospitalName }}
                              <span v-if="item.contactedNumber"> ({{ item.contactedNumber }})</span>
                            </span>
                          </div>
                        </td>
                        <td class="tableitems">
                          {{ item.actionByName || (item.actionBy && item.actionBy.name) || "-" }}
                        </td>
                        <td class="tableitems">{{ item.actionByRole || "-" }}</td>
                        <td class="tableitems">{{ item.district || "-" }}</td>
                        <td class="tableitems">
                          {{ (item.snakebite && item.snakebite.name) || "-" }}
                        </td>
                        <td class="tableitems text-center">
                          <v-icon
                            small
                            color="success"
                            v-if="item.snakebite"
                            @click="openIncident(item)"
                            title="View Incident"
                            class="cursor-pointer"
                          >
                            mdi-eye
                          </v-icon>
                          <span v-else>-</span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </v-flex>

          <v-flex xs12 pt-16 v-else>
            <v-layout wrap justify-center>
              <v-flex xs12 class="text-center">
                <v-icon size="48" color="#c8d6c8">mdi-clipboard-text-outline</v-icon>
                <div class="nodata pt-2">No Activity Found !</div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pt-4 v-if="items && items.length > 0">
            <v-layout wrap justify-center>
              <v-flex xs10>
                <v-pagination
                  v-model="currentPage"
                  :length="pageLength"
                  :total-visible="7"
                  circle
                  color="#427D2D"
                  small
                ></v-pagination>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      items: [],
      currentPage: 1,
      count: 15,
      pageLength: 0,

      fromDate: null,
      toDate: null,
      menuFrom: false,
      menuTo: false,
      district: "All",
      role: "All",
      actionType: "All",
      keyword: "",

      districtOptions: ["All"],
      roleOptions: ["All", "MedicalOfficer", "District Emergency Officer", "admin"],
      actionTypeOptions: ["All"],
    };
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
  },
  watch: {
    currentPage() {
      this.getData();
    },
    fromDate() {
      this.currentPage = 1;
      this.getData();
    },
    toDate() {
      this.currentPage = 1;
      this.getData();
    },
    district() {
      this.currentPage = 1;
      this.getData();
    },
    role() {
      this.currentPage = 1;
      this.getData();
    },
    actionType() {
      this.currentPage = 1;
      this.getData();
    },
    keyword() {
      this.currentPage = 1;
      this.getData();
    },
  },
  beforeMount() {
    this.getDistricts();
    this.getActionTypes();
    this.getData();
  },
  methods: {
    getDistricts() {
      axios({
        method: "GET",
        url: "/state/districts",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          if (response.data.status && response.data.data) {
            this.districtOptions = ["All"].concat(response.data.data);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    getActionTypes() {
      axios({
        method: "GET",
        url: "/snakebite/action/types",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          if (response.data.status && response.data.data) {
            this.actionTypeOptions = ["All"].concat(response.data.data);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/state/activity/log",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: {
          page: this.currentPage,
          limit: this.count,
          fromDate: this.fromDate,
          toDate: this.toDate,
          district: this.district,
          role: this.role,
          actionType: this.actionType,
          keyword: this.keyword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.items = response.data.data || [];
            this.pageLength = response.data.pages || 0;
          } else {
            this.items = [];
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    detailPath() {
      if (this.userRole === "MedicalOfficer")
        return "/medicalOfficers/snakebiteAlertView";
      if (this.userRole === "District Emergency Officer")
        return "/DistrictEmergencyOfficer/snakebiteAlertView";
      if (this.userRole === "StateMedicalOfficer" || this.userRole === "State Medical Officer")
        return "/stateMedical/snakebiteAlertView";
      if (this.userRole === "Disaster Management Officer" || this.userRole === "DisasterManagementOfficer")
        return "/disaster/snakebiteAlertView";
      return "/snakebiteAlertView";
    },

    openIncident(item) {
      var id = item.snakebite && item.snakebite._id ? item.snakebite._id : item.snakebite;
      if (!id) return;
      this.$router.push({ path: this.detailPath(), query: { snakebiteId: id } });
    },

    pad(n) {
      return n < 10 ? "0" + n : "" + n;
    },

    formatDateTime(value) {
      if (!value) return "-";
      var d = new Date(value);
      if (isNaN(d.getTime())) return "-";
      var h = d.getHours();
      //midnight and noon both read as 12 on a 12-hour clock, not 0
      var hour12 = h % 12 === 0 ? 12 : h % 12;
      return (
        this.pad(d.getDate()) +
        "-" +
        this.pad(d.getMonth() + 1) +
        "-" +
        d.getFullYear() +
        " " +
        this.pad(hour12) +
        ":" +
        this.pad(d.getMinutes()) +
        " " +
        (h < 12 ? "AM" : "PM")
      );
    },
  },
};
</script>

<style scoped>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subtext {
  font-family: poppinsregular;
  font-size: 12.5px;
  color: #6b7a66;
}
.tablehead {
  font-family: poppinsregular;
  font-size: 12.5px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  text-transform: uppercase !important;
  white-space: nowrap;
  vertical-align: middle !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.tableitems {
  font-family: poppinsregular;
  font-size: 12.5px;
  white-space: nowrap;
  vertical-align: middle !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.descriptioncell {
  white-space: normal;
  min-width: 260px;
  max-width: 420px;
  line-height: 1.4;
}
.main-desc {
  word-break: break-word;
}
.detailline {
  font-size: 11px;
  color: #6b7a66;
  padding-top: 4px;
}
.detail-chip {
  display: inline-block;
  margin-right: 8px;
  margin-top: 2px;
  white-space: nowrap;
}
.action-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef6ef;
  border-radius: 8px;
  padding: 3px 10px;
  font-size: 11.5px;
  font-weight: 500;
  color: #38513a;
  white-space: nowrap;
}
.cursor-pointer {
  cursor: pointer;
}
.nodata {
  font-family: poppinsregular;
  font-size: 15px;
  color: #8a998a;
}
</style>
